const { $q } = require('angular-ui-router')

angular.module('common.services').factory('edgeFactoryV2', [
  '$http',
  '$filter',
  '$localStorage',
  '$q',
  function ($http, $filter, $localStorage, $q) {
    this.list = []

    this.clear = function () {
      this.list = []
    }

    this.findItemById = function (id) {
      var returnValue = {
        status: 0
      }
      const [item] = this.list.filter(e => e.id == id)
      if (item) {
        returnValue.status = 1
        returnValue.item = item
        returnValue.index = this.list.indexOf(returnValue.item)
      }
      return returnValue
    }

    this.findItemByImei = function (imei) {
      var returnValue = {
        status: 0
      }
      const [item] = this.list.filter(e => e.imei == imei)
      if (item) {
        returnValue.status = 1
        returnValue.item = item
        returnValue.index = this.list.indexOf(returnValue.item)
      }
      return returnValue
    }

    this.findItemByDeviceSerial = function (deviceSerial) {
      var returnValue = {
        status: 0
      }
      var item = $filter('filter')(this.list, function (e) {
        return e.uri == deviceSerial
      })
      if (item.length > 0) {
        returnValue.status = 1
        returnValue.item = item[0]
        returnValue.index = this.list.indexOf(returnValue.item)
      }
      return returnValue
    }
    this.addOrUpdateItem = function (item) {
      if (item.edge_type == 2 && item.locationStatus === undefined) {
        // throw new Error();
      }
      var itemData = this.findItemByImei(item.imei)
      if (itemData.status == 1) {
        this.list[itemData.index] = item
      } else {
        this.list.push(item)
      }
    }
    this.deleteItemById = function (id) {
      var itemData = this.findItemById(id)
      if (itemData.status == 1) {
        var index = itemData.index
        this.list.splice(index, 1)
      }
    }

    this.deleteItemByImei = function (imei) {
      var itemData = this.findItemByImei(imei)
      if (itemData.status == 1) {
        var index = itemData.index
        this.list.splice(index, 1)
      }
    }

    /**
     * @name getSingleDevice
     * @desc Get device data from organization based on IMEI number
     * @param {Number} organizationId Organization ID
     * @param {String} deviceImei Device IMEI number
     * @returns {Promise} A device data
     */
    this.getSingleDevice = function (organizationId, deviceImei, config) {
      return $http({
        method: 'GET',
        url: `${V2_BASEURL}/organizations/${organizationId}/devices`,
        params: { imei: deviceImei },
        ...config,
        headers: {
          source: 'x-surfsight-internal'
        }
      }).then(response => {
        return response.data.data[0]
      })
    }

    /**
     * @name addDevice
     * @desc Add new device to organization
     * @param {Number} organizationId Organization ID
     * @param {String} deviceImei Device IMEI number
     * @param {String} deviceName Name that will be set for a new device
     * @returns {Promise} Newly added device object
     */
    this.addDevice = function (organizationId, deviceImei, deviceName) {
      return $http({
        method: 'POST',
        url: `${V2_BASEURL}/organizations/${organizationId}/devices`,
        data: {
          imei: deviceImei, // $scope.newedge.uri,
          name: deviceName
        }
      })
    }

    /**
     * @name deleteDevice
     * @desc Delete device
     * @param {Number} organizationId Organization ID
     * @param {String} deviceImei Device IMEI number
     * @returns {Promise} requestId
     */
    this.deleteDevice = function (organizationId, deviceImei) {
      return $http({
        method: 'DELETE',
        url: `${V2_BASEURL}/organizations/${organizationId}/devices/${deviceImei}`
      })
    }

    /**
     * @name updateDevice
     * @desc Update device by changing its name
     * @param {String} deviceImei Device IMEI number
     * @param {Number} newName New name for a device
     * @returns {Promise} requestId
     */
    this.updateDevice = function (deviceImei, newName) {
      return $http({
        method: 'PATCH',
        url: `${V2_BASEURL}/devices/${deviceImei}`,
        data: { name: newName }
      })
    }

    /**
     * @name getDemoMode
     * @desc Get demo mode status for a device
     * @param {String} deviceImei Device IMEI number
     * @returns {Promise} Demo mode status
     */
    this.getDemoMode = function (deviceImei) {
      return $http({
        method: 'GET',
        url: `${DEVICEMANAGER_BASEURL}/device/${deviceImei}/demo_mode`
      })
    }

    /**
     * @name updateDemoMode
     * @desc Update demo mode status for a device
     * @param {String} deviceImei Device IMEI number
     * @param {Boolean} demoModeStatus New demo mode status
     * @returns {Promise} requestId
     */
    this.updateDemoMode = function (deviceImei, demoModeStatus) {
      return $http({
        method: 'PUT',
        url: `${DEVICEMANAGER_BASEURL}/device/${deviceImei}/demo_mode`,
        data: { value: demoModeStatus }
      })
    }

    /**
     * @name updateDemoModeV2
     * @desc Update demo mode status for AI-14 device
     * @param {String} deviceImei Device IMEI number
     * @param {Boolean} demoModeStatus New demo mode status
     * @returns {Promise} requestId
     */
    this.updateDemoModeV2 = function (deviceImei, demoModeStatus) {
      return $http({
        method: demoModeStatus === true ? 'PUT' : 'DELETE',
        url: `${V2_BASEURL}/devices/${deviceImei}/demo-mode`,
        data: {}
      })
    }

    /**
     * @name getDevicesByImeiNumbers
     * @desc Get device data from organization based on IMEI number
     * @param {Number} organizationId Organization ID
     * @param {Array} imeiNumbers Devices IMEI numbers
     * @returns {Promise} Devices
     */
    this.getDevicesByImeiNumbers = function (organizationId, imeiNumbers) {
      const requests = imeiNumbers.map(imei =>
        this.getSingleDevice(organizationId, imei)
      )
      return $q.all(requests)
    }

    /**
     * @name getDevicesByGroup
     * @desc Get device data from organization based on group ID
     * @param {Number} organizationId Organization ID
     * @param {Number} groupId Group ID
     * @returns {Promise} Devices
     */
    this.getDevicesByGroup = function (organizationId, groupId, name = '') {
      return $http({
        method: 'GET',
        url: `${V2_BASEURL}/organizations/${organizationId}/devices`,
        params: {
          groupId,
          name
        },
        headers: {
          source: 'x-surfsight-internal'
        }
      }).then(({ data: { data } }) => data)
    }

    /**
     * @name getDevicesByGroups
     * @desc Get all devices data from organization withing provided group IDs
     * @param {Number} organizationId Organization ID
     * @param {Array} groupIds Group IDs
     * @returns {Promise} Devices
     */
    this.getDevicesInGroups = function (organizationId, groupIds, name = '') {
      const requests = groupIds.map(groupId =>
        this.getDevicesByGroup(organizationId, groupId, name)
      )
      return $q.all(requests).then(responses => {
        return [].concat.apply([], responses)
      })
    }

    /**
     * @name getDeviceSettings
     * @desc Get settings for a device
     * @param {String} deviceImei Device IMEI number
     * @returns {Promise} List of settings for a device
     */
    this.getDeviceSettings = function (deviceImei) {
      return $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/device-config`
      }).then(response => {
        const responseData = response.data.data
        if (responseData.standby) {
          const value = responseData.standby.timeout
          delete responseData.standby.timeout
          responseData.standby.value = value
        }
        return {
          ...response,
          data: {
            ...response.data,
            data: responseData
          }
        }
      })
    }

    /**
     * @name getDevicePrivacyModeConfig
     * @desc Get privacy settings for a device
     * @param {String} deviceImei Device IMEI number
     * @returns {Promise} List of settings for a device
     */
    this.getDevicePrivacyModeConfig = function (deviceImei) {
      const privacyConfigRequest = $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/privacy-config`
      })

      const privacyControlRequest = $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/privacy-control`
      })
      return $q
        .all([privacyConfigRequest, privacyControlRequest])
        .then(([privacyConfigResponse, privacyControlResponse]) => {
          const privacyConfigData = privacyConfigResponse.data.data
          const privacyControlData = privacyControlResponse.data.data
          return {
            data: {
              privacySettings: privacyConfigData.privacyConfig,
              privacyMode: privacyControlData.privacyMode
            }
          }
        })
    }

    /**
     * @name updateDevicePrivacyModeSettings
     * @desc Update privacy settings for a device
     * @param {Array} imeis of devices
     * @returns {Promise} List of settings for a device
     */
    this.updateDevicePrivacyModeSettings = function (deviceImeis, privacyMode) {
      return $http({
        method: 'POST',
        url: `${V2_BASEURL}/devices/privacy-control`,
        data: {
          imeis: deviceImeis,
          privacyMode
        }
      })
    }
    /**
     * @name updateDevicePrivacyModeSettingsV1
     * @desc Update privacy settings for a device
     * @returns {Promise} List of settings for a device
     */
    this.updateDevicePrivacyModeSettingsV1 = function (
      privacyMode,
      bulkDevicesSelections
    ) {
      return $http({
        method: 'POST',
        url: `${DEVICEMANAGER_BASEURL}/v1.1/devices/privacy-control`,
        data: {
          privacyMode,
          bulkDevicesSelections
        }
      })
    }
    /**
     * @name updateDevicesPrivacySettingsV1
     * @desc Update privacy settings for a device
     * @returns {Promise} List of settings for a device
     */
    this.updateDevicesPrivacySettingsV1 = function (
      privacyConfig,
      bulkDevicesSelections
    ) {
      return $http({
        method: 'PATCH',
        url: `${DEVICEMANAGER_BASEURL}/v1.2/devices/bulk/privacy-config`,
        data: {
          privacyConfig,
          bulkDevicesSelections
        }
      })
    }

    /**
     * @name updateDevicesPrivacyModeSettings
     * @desc Update privacy settings for a device
     * @param {Array} deviceImeis Devices IMEI numbers
     * @returns {Promise} List of settings for a device
     */
    this.updateDevicesPrivacySettings = function (deviceImeis, privacyConfig) {
      return $http({
        method: 'PATCH',
        url: `${V2_BASEURL}/devices/bulk/privacy-config`,
        data: {
          imeis: deviceImeis,
          privacyConfig
        }
      })
    }
    /**
     * @name updateDeviceSettings
     * @desc Get settings for a device
     * @param {String} deviceImei Device IMEI number
     * @param {Array} deviceSettings Array of objects that represent settings and new values for each setting
     * @returns {Promise} requestId
     */
    this.updateDeviceSettings = function (deviceImei, deviceSettings) {
      if (deviceSettings.standby) {
        const value = deviceSettings.standby.value
        delete deviceSettings.standby.value
        deviceSettings.standby.timeout = value
      }

      // sanitize device settings for non-MQTT based devices
      const sanitizedDeviceSettings = window.sanitizeSettingsForDevice(
        deviceImei,
        deviceSettings
      )

      return $http({
        method: 'PUT',
        url: `${V2_BASEURL}/devices/${deviceImei}/device-config`,
        data: sanitizedDeviceSettings
      })
    }

    /**
     * @name getRecordingAvailability
     * @desc Get recording availability info for a device
     * @param {Number} organizationId Organization ID
     * @param {String} deviceImei Device IMEI number
     * @returns {Promise} Recording intervals for all cameras attached to a device
     */
    this.getRecordingAvailability = function (deviceImei, startDate, endDate) {
      return $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/recording-ranges`,
        params: {
          start: startDate,
          end: endDate
        }
      })
    }

    /**
     * @name getActiveCameras
     * @desc Get active cameras for seleted device
     * @param {String} deviceImei Device IMEI number
     * @returns {Promise} Active cameras IDs
     */
    this.getActiveCameras = function (deviceImei) {
      return $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/cameras`,
        headers: {
          'x-media-token': $localStorage.userMediaAccessToken
        }
      }).catch(error => {
        if (error.status === 417) {
          return {
            data: {
              data: [],
              requestId: error.data.requestId
            }
          }
        } else {
          throw error
        }
      })
    }

    /**
     * @name getDeviceTelemetry
     * @desc This API returns device telemetry, the device must be online for this endpoint to returns telemetry
     * @param {String} deviceImei Device IMEI number
     * @returns {Promise} Online device details
     */
    this.getDeviceTelemetry = deviceImei =>
      $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/telemetry`
      }).then(({ data: { data } }) => data)

    /**
     * @name prepareDeviceMediaStreaming
     * @desc This call will return the URL to retrieve a recording or live video and an authentication token for required for the URL,
     *        the token is valid for 30 minutes. After that it can be renewed using the same API, this call will have to be called again
     *        if a device does not start streaming within 2 minutes.
     * @param {String} deviceImei Device IMEI number
     * @param {Promise} timeout handle in case of timeout
     * @returns {Promise} Address of media server and media token
     */
    this.prepareDeviceMediaStreaming = (deviceImei, timeout) =>
      $http({
        method: 'POST',
        url: `${V2_BASEURL}/devices/${deviceImei}/connect-media`,

        timeout
      }).then(({ data: { data } }) => data)

    /**
     * @name getDeviceEvents
     * @desc Returns list of events in the given time range. Note: retention period of events is 30 days
     * @param {String} deviceImei Device IMEI number
     * @param {String} start Date in the format ISO 8601
     * @param {String} end Date in the format ISO 8601
     * @returns {Array} List of events
     */
    this.getDeviceEvents = (deviceImei, start, end) =>
      $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/events`,
        params: { start, end }
      }).then(({ data: { data } }) => data)

    /**
     * @name getDeviceEventFileLink
     * @desc This API is used to obtain a file attached to an event generated by the given device. This API can be used in 2 different flows. The first flow is quering for occured events in a given period of time and then downloading the files for those events. In this case all information required to use this API is available in the event object received from events API. The second flow is when a virtual event is generated and a user wants to access the event files without quering for events using /devices/{imei}/events API. In this case the user should have some additional info like virtual event configuration on the device and IDs of the connected cameras to the device. In case of virtual event the fileId parameter can be set to be unit timestamp (seconds from epoch) of the event. Note that this is applicable only to virtual events. For all other events fileId must be obtained from /devices/{imei}/events response.
     * @param {String} deviceImei Device IMEI number
     * @param {String} cameraId
     * @param {String} fileId
     * @param {String} fileType
     * @returns {String} Link to file
     */
    this.getDeviceEventFileLink = (deviceImei, cameraId, fileId, fileType) =>
      $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/event-file-link`,
        params: {
          cameraId,
          fileId,
          fileType
        }
      }).then(({ data: { data } }) => data)

    // todo: remove after full migration to V2
    /**
     * @name getEdgeIdByImei
     * @desc This API returns device ID
     * @param {String} deviceImei Device IMEI number
     * @returns {Integer} Device ID
     */
    this.getEdgeIdByImei = deviceImei =>
      $http({
        method: 'GET',
        url: `${EDGE_BASEURL}/v1.1/devices/${deviceImei}/edge`
      }).then(({ data: { id } }) => id)

    /**
     * @name getImeiByEdgeId
     * @desc This API returns device IMEI
     * @param {String} edgeId Edge ID number
     * @returns {Integer} Device IMEI
     */
    this.getImeiByEdgeId = edgeId =>
      $http({
        method: 'GET',
        url: `${EDGE_BASEURL}/edge/${edgeId}`
      }).then(({ data }) => data)

    // todo: remove after full migration to V2
    this.getEdgeSpeed = (data, deviceImei) =>
      this.getEdgeIdByImei(deviceImei).then(id =>
        $http({
          method: 'POST',
          url: `${EDGE_BASEURL}/edge/${id}/speed`,
          data: data
        }).then(({ data }) => data)
      )

    this.getEventsByImei = function (deviceImei, startDate, endDate) {
      return $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/events`,
        params: {
          start: startDate,
          end: endDate
        }
      }).then(eventsData => {
        return eventsData.data.data
      })
    }

    return this
  }
])
